var config = {
  env: "production",
  development: {
    baseUrl: "http://192.168.1.24:8080/api"
  },
  production: {
    baseUrl: "https://api.rotzler.com/api"
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js